const $        = require('jquery');
const Backbone = require('backbone');

module.exports = {

    /**
     * @param {String} route
     * @param {Object} [options]
     * @returns {Boolean}
     */
    navigate: function (route, options) {
        options = options || {};
        Backbone.history.navigate(route.toString(), options);

        let path = route.toString().replace('/', '#');
        if (!path || path === '#') {
            path = '#home';
        }

        let $li   = $('aside').find('li');
        let $item = $li.find('a[href="' + path + '"]');
        if ($item.length) {
            $li.removeClass('active');
            $item.parents('li').addClass('active');
        }

        return true;
    },

    /**
     * Packages
     */
    showPackages: function () {
        let controller = this;
        require(['./packages/main'], (View) => {
            controller._showMainView(View, 'packages');
        });
    },

    /**
     * Home
     */
    showHome: function () {
        let controller = this;
        require(['./home/main'], (View) => {
            controller._showMainView(View, '/');
        });
    },

    /**
     * @param {Function}  View
     * @param {String}    [url]
     * @param {Object}    [options]
     * @private
     */
    _showMainView: function (View, url, options) {
        let controller = this;
        require(['./main'], (App) => {
            if (url) {
                controller.navigate(url);
            }

            let view = new View(options);
            App.UI.showChildView('main_region', view);
        });
    }
};
